var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',_vm._g(_vm._b({attrs:{"color":"natural darken-2","timeout":-1}},'v-snackbar',_vm.$attrs,false),_vm.inputListeners),[_c('v-avatar',{attrs:{"size":"30"}},[_c('v-icon',{attrs:{"width":"25"}},[_vm._v(_vm._s(_vm.iconWifiOff))])],1),_c('span',{staticClass:"ml-8"},[_vm._v("ไม่สามารถเชื่อมต่ออินเตอร์เน็ต")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }